<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="轨道列表" name="first"></el-tab-pane>
      <!-- <el-tab-pane label="联创股东" name="fourth"></el-tab-pane> -->
      <el-tab-pane label="团队长业绩" name="second2"></el-tab-pane>
      <el-tab-pane label="团队长业绩明细" name="second"></el-tab-pane>
      <el-tab-pane label="基础设置" name="third"></el-tab-pane>
      
    </el-tabs>

    <!--秒杀活动-->
    <Active v-if="activeName == 'first'"></Active>
    <GroupLog v-if="activeName == 'second2'"></GroupLog>
    <Log v-if="activeName == 'second'"></Log>

    <!--基础设置-->
    <Setting v-if="activeName == 'third'"></Setting>
    <Agent v-if="activeName == 'fourth'"></Agent>
  </div>
</template>
<script>
import Active from './active/index';
import Log from './log/index';
import Agent from './agent/index';
import GroupLog from './grouplog/index';
import Setting from './setting/getSetting.vue';
export default {
  components: {
    Active,
    Log,
    Agent,
    GroupLog,
    Setting
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/multigroup/index.vue